// Where something moved to, said where it used to be (the setup audit, 24 Oct): for a release, a
// screen that lost a part to Setup says so with a link to its new home, then the line goes.

export function Moved({ what, to, href }: { what: string; to: string; href: string }) {
  return (
    <p className="muted small bp-moved" role="note">
      {what} moved to <a href={href}>{to}</a>.
    </p>
  );
}
